module.exports = __webpack_public_path__ + "img/honorary2.5598db35.jpg";